import { createSlice } from '@reduxjs/toolkit';
// api
import { getInterviewGroup, getPhaseTaskList } from '../../api/panel';
// ----------------------------------------------------------------------

const initialState = {
  isLoading: false,
  groupData: {},
  panelList: [],
  // 是否打开学生详细资料的模态框
  isOpenDetail: false
};

const slice = createSlice({
  name: 'panel',
  initialState,
  reducers: {
    // START LOADING
    startLoading(state) {
      state.isLoading = true;
    },
    getGroupDataSuccess(state, action) {
      state.isLoading = false;
      state.groupData = action.payload;
    },
    getPanelListSuccess(state, action) {
      state.isLoading = false;
      state.panelList = action.payload;
    },
    // HAS ERROR
    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },
    setIsOpenDetail(state, { payload }) {
      state.isOpenDetail = payload;
    }
  },
});

export const { getGroupDataSuccess, getPanelListSuccess, startLoading, setIsOpenDetail } = slice.actions;
// Reducer
export default slice.reducer;

// ----------------------------------------------------------------------
export function getGroupData(id) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await getInterviewGroup(id);
      dispatch(slice.actions.getGroupDataSuccess(response));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}
export function getPanelList({ phaseId, timeId }) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await getPhaseTaskList({ phaseId, timeId });
      dispatch(slice.actions.getPanelListSuccess(response));
    } catch (error) {
      dispatch(slice.actions.getPanelListSuccess([]));
      dispatch(slice.actions.hasError(error));
    }
  };
}
